// ADL
import $ from 'jquery';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import frm from '../formAux.js';
var descriptor = [];
var txtObj = null;
var txtObjAdj = null;
var gPDF = null;
var txtTags = null;
var tListAdj = null;
var pageNum = null;
var mode = 'adl';

var closeIcon = '';
var searchIcon = '';

// ADLEND

// NPLEXPORTSTART
function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

function keyObj(v,defVal)
{
	var o = {}
	if( typeof(v) == 'string' )
	{
		o[v] = 1;
		return o;
	}
	if( isarray(v) )
	{
		v.forEach(s => o[s] = 1);
		return o;
	}
	if( isobj(v) )
	{
		for( var s in v) o[s] = 1;
		return o;
	}
	if( isobj(defVal) )
	{
		for( var s in defVal ) o[s] = 1;
		return o;
	}
	return {};
}

function Tabler( obj, descriptor, ctxId )
{
	var saveContext = function(){};
	this.descriptor = descriptor;
	var dc = descriptor;
	if( ctxId )
	{
		var ctx = getCtx(ctxId);
		// alert( ctx )
		for( var c in ctx )
		{
			dc[c] = ctx[c];
			// console.log( 'CTX SET', c, ctx[c], dc[c])
		}
	}
	dc.clickCol = keyObj( dc.clickCol, dc.columns );
	dc.clickAllCols = Object.keys(dc.clickCol).length == Object.keys(dc.columns).length;
	dc.noClick = keyObj( dc.noClick );
	dc.noSort = keyObj( dc.noSort );
	dc.noFilter = keyObj( dc.noFilter );
	dc.noSearch = keyObj( dc.noSearch );
	if( !dc.maxLinesCol ) dc.maxLinesCol = [];
	if( !dc.formatCol ) dc.formatCol = {};
	if( !dc.forceType ) dc.forceType = {};
	if( 'centerCol' in dc )	dc.centerCol = keyObj( dc.centerCol, dc.columns );
	else dc.centerCol = {}
	// console.log( 'CENTERCOL', dc.centerCol )
	let me = this;
	me.drawn = false;
	me.update = true;
	dc.colType = {};
	if( !dc.selected ) dc.selected = {};
	if( !dc.headerClick ) dc.headerClick = 'filter';
	for( var c in dc.columns ) dc.colType[c] = 1; // number
	function sortClick( ev )
	{
		var sel = $(ev.target);
		var dir = sel.prop('sort_dir');
		if( !dir ) dir = -1;
		dir *= -1;
		$(obj).find('.tabler-sort').removeClass('tabler-active');
		var idx = sel.prop('idx');
		if( dir < 0 )
		{
			sel.removeClass('fa-caret-up').addClass('fa-caret-down').addClass('tabler-active').prop('sort_dir',dir);
		}
		else
		{
			sel.removeClass('fa-caret-down').addClass('fa-caret-up').addClass('tabler-active').prop('sort_dir',dir);
		}
		var sortVar = Object.keys(dc.columns)[idx];
		sortData( sortVar, dir )
		saveContext();
		ev.stopPropagation();
	}

	var filters = dc.filters || {};
	dc.filters = filters;
	function sortData( v, dir )
	{
		filterOut();
		// console.log( 'sortData', v, dir )
		var allNum = true;
		me.rows.forEach( r => {
			if( v in dc.forceType )
			{
				var f =  dc.forceType[v];
				if( f == 0 ) r.sort = (r.data[v] || '').toString();
				else if( f == 2 ) r.sort = parseInt(r.data[v]) || 99999999999999999999999;
				// else if( f  == 2 ) r.sort = parseInt(r.data[v]) || 1625547537503;
				else r.sort = parseInt(r.data[v]) || 0;
			}
			else
				r.sort = r.filter[v]  || r.data[v];
			// console.log( 'sort', v, dc.colType[v], r.sort, r.data[v], (r.data[v]||9999999999999999999999999) )
			// if( typeof(r.sort) == 'string' ) r.sort = r.sort.replace( /(<([^>]+)>)/ig, '').toLowerCase();
		});
		// me.rows.forEach( r => console.log( 'sort', r, r.sort ))
		me.rows.sort( function(a,b){
			return a.sort > b.sort ? 1*dir : -1*dir;
		});
		// console.log( 'MMMMMMMMMMMMMMMMMMEEEEE', me.rows, v )
		dc.initialSort = v;
		dc.initialSortDir = dir;
		me.draw();
	}
	// $(obj).on('click',filterOut);

	function filterClick( ev )
	{
		var fter = $(ev.target);
		var idx = fter.prop('idx');
		var filterVar = Object.keys(dc.columns)[idx];
		var th = fter.closest('th');
		var open = th.hasClass('tabler-filter-open');
		filterOut();
		if( open ) return;
		th.addClass('tabler-filter-open');
		// console.log( th[0].getBoundingClientRect(), th.position() );
		var pos = th.position();
		var table = th.closest('table');
		var tp = table.position();
		console.log( 'TABLEPOS', tp );
		var filterBg = $('<div>').addClass('tabler-filter-bg').css(
			{
				top:tp.top,
				left:tp.left,
				width:table.outerWidth(),
				height:table.outerHeight(),
			});
		var filter = $('<DIV>').css({position:'absolute',top:pos.top+th.outerHeight()}).addClass('tabler-filter-popup')
		table.parent().append(filterBg);
		frm.eventOutside( filter, 'click', filterOut )
		table.parent().append(filter);
		filterBg.on('click', filterOut )
		var leftOff = th.outerWidth()-filter.outerWidth()
		if( leftOff < 0 ) leftOff = 0;
		var left = pos.left+leftOff;

		filter.css({left:left});
		// check if filter hast passed the table right side
		var bobj = $(obj)[0].getBoundingClientRect();
		var bfilter = filter[0].getBoundingClientRect()
		var fr = bfilter.left+bfilter.width;
		var br = bobj.left+bobj.width;
		if( br-fr < 0 )
		{
			left += br-fr;
			filter.css({left:left});
		}
		me.filter = filter;
		me.filterBg = filterBg;
		var search = $('<INPUT TYPE="text" placeholder="Search">').on('keyup',filterSearch);
		filter.append(search);

		var opts = $('<DIV>').addClass('tabler-filter-opts scroll-white');
		filter.append(opts);
		var clear = $('<div>').html('clear').addClass('tabler-filter-clear').on('click',filterClear);
		filter.append( clear );
		search.focus();

		function filterSearch(ev)
		{
			console.log( ev.keyCode )
			var sval = search.val().toLowerCase().trim().replace();
			if( ev.keyCode == 13 && searchMatch.length )
			{
				if( sval > '' )
				{
					if( !filters[filterVar] ) filters[filterVar] = {};
					searchMatch.forEach( m => filters[filterVar][m] = 1)
				}
				else {
					delete filters[filterVar];
				}
				filterPaint();
				filterOut();
				return;
			}
			filterOptions( search.val() )

		}

		function filterClear()
		{
			delete filters[filterVar];
			filterOut();
			filterPaint();
		}

		var searchMatch = [];
		function filterOptions( search )
		{
			searchMatch = [];
			opts.html('');
			var vals = {};
			var added = clone(filters[filterVar] || {});
			var v = filterVar;
			filterRows( filterVar ).forEach( r => {
				if( isarray(r.filter[filterVar]) )
					for( var v of r.filter[filterVar] ) vals[v] = 1;
				else 
					vals[r.filter[filterVar]] = 1;
			});
			var vals = Object.keys(vals);
			vals.sort();
			var set = filters[filterVar];
			if( !set ) set = {};
			var slist = search && search.replace(/ *([\+\-\|]) */g, " $1" ).replace(/ +/g, ' ').toLowerCase().split(' ') || [];
			while( slist.length && !slist[0] ) slist.shift();
			if( !slist.length ) slist = [null];
			// console.log( 'filterOptions', search, slist );
			slist.forEach( (search,idx) => {
				var and = {};
				var op = idx ? 'and' : 'or';
				if( search && search[0] == '|' && idx )
				{
					op = 'or';
					search = search.substr(1);
				}
				// if( search && search[0] == '-' )
				// {
				// 	op = 'not';
				// 	search = search.substr(1);
				// 	if( idx == 0 )
				// 	{
				// 		console.log( 'pre not' )
				// 		vals.forEach( v => {
				// 			filterAddOpt( v, 0 );
				// 			added[v] = 2;
				// 		});
				// 	}
				// }

				console.log( 'search', op, search, idx, 'added', Object.keys(added) );
				var saveSet = clone(filters[filterVar] || {});
				vals.forEach( v => {
					if( !search && idx ) return;

					if( !search || v.toString().toLowerCase().indexOf(search) >= 0 )
					{
						if( op == 'or' )
						{
							if( added[v] != 2 ) filterAddOpt( v, set[v] );
							added[v] = 2;
						}
						else if( op == 'not' )
						{
							if( added[v] )
							{
								console.log( 'remove', v )
								delete added[v];
								filterDelOpt( v );
							}
						}
						else // and
						{
							and[v] = v;
						}
					}
				})
				if( op == 'and' && search )
				{
					for( var v in added ) if( !and[v] )
					{
						delete added[v];
						filterDelOpt( v );
					}
				}
				console.log( 'cycle', Object.keys(added))
				// console.log( clone(set) );
				// if( op == 'and' )
				// {
				// 	vals.forEach( v => {
				// 		if( saveSet[v] != set[v] ) delete set[v];
				// 	});
				// }
			})
			searchMatch = Object.keys(added);
			console.log( 'searchMatch', searchMatch )
		}

		function filterOptClick( ev )
		{
			var opt = $(this);
			var fval = opt.prop('filter-val');
			var isset = opt.prop('isset')
			isset = !isset;
			if( !isset )
			{
				delete filters[filterVar][fval];
				if( Object.keys(filters[filterVar]).length == 0 ) delete filters[filterVar];
			}
			else
			{
				if( !filters[filterVar] ) filters[filterVar] = {};
				filters[filterVar][fval] = 1;
			}
			opt.prop('isset',isset);
			opt.find('i').removeClass('fa-check-square-o').removeClass('fa-square-o').addClass(isset?'fa-check-square-o' : 'fa-square-o');
			console.log( opt[0], fval, isset );
			filterPaint();
		}

		function filterAddOpt( v, isset )
		{
			// console.log( 'add', v );
			var o = $('<div>').addClass('tabler-filter-option').prop('filter-val',v).prop('isset',isset);
			var ck = $('<i>').addClass('fa').addClass( isset ? 'fa-check-square-o' : 'fa-square-o');
			o.append( ck );
			var vtxt = v > '' ? v : '<span class="tabler-blank">blank</span>'
			var txt = $('<span>').html(vtxt);
			o.append( txt );
			o.on('click', filterOptClick )
			opts.append(o);
		}

		function filterOptFind( v )
		{
			var olist = opts.find('.tabler-filter-option');
			olist = Array.from(olist);
			for( var o of olist )
			{
				if( $(o).prop('filter-val') == v )
				{
					// console.log( 'find', o )
					return $(o);
				}
			}
			return null;
		}

		function filterDelOpt( v )
		{
			// console.log( 'del', v )
			var dopt = filterOptFind( v );
			if( dopt )
			{
				dopt.remove();
			}
		}

		filterOptions();
		ev.stopPropagation();
		// ev.preventDefault();
		saveContext();
	}
	function filterOut()
	{
		frm.eventOutsideEnd();
		$(obj).find('.tabler-filter-open').removeClass('tabler-filter-open');
		if( me.filter ) me.filter.remove();
		if( me.filterBg ) me.filterBg.remove();
		saveContext();
	}
	function filterPaint( nodraw )
	{
		var idx = 0;
		$(obj).find('.tabler-filter-btn').removeClass('tabler-active');
		$(obj).find('.tabler-th').removeClass('tabler-title-active');
		for( var c in dc.columns )
		{
			if( filters[c] )
			{
				$(obj).find('.tabler-th-'+idx).addClass('tabler-title-active');
				$(obj).find('.tabler-filter-'+idx).addClass('tabler-active');
			}
			idx++;
		}
		if( nodraw ) return;
		me.update = true;
		me.draw();
	}

	function drawHeader()
	{
		$(obj).html('').addClass('tabler').removeClass('table-grid table table-sm table-bordered table-hover');
		var th = $('<thead>');
		var cols = dc.columns;
		var ncols = Object.keys(cols).length;
		var tr = $('<tr>').addClass('tabler-title');
		if( dc.selectMode ) ncols++;
		var title = $('<th>').html(dc.title).attr('colspan',ncols);
		title.append( $('<DIV>').addClass('pagination').html('pagination'))
		// title.append( $('') );
		tr.append(title).addClass('tabler-header');
		th.append(tr);
		var tr = $('<tr>');
		$(obj).append(th);
		th.append(tr);
		var idx = 0;
		dc.colNum = {};
		if( dc.selectMode )
		{
			// var td = $('<th>').html( '<span class="tabler-htit">'+scheck(0)+'</span><span class="tabler-hbut"></span>');
			// var td = $('<th>').html( '<span class="tabler-htit">aaa</span>');
			var td = $('<th>').html(scheck(0));
			// var td = $('<th>').html( 'aaa');
			if( dc.headerClick ) td.css({cursor:'pointer'}).prop('idx',idx).on('click', selectAllClick ).addClass('tabler-sel-col-header');
			tr.append(td);
		}
		for( var c in cols )
		{
			dc.colNum[c] = idx;
			var paddingRight = 0;
			var txt = '<span class="tabler-htit">' + cols[c] + '</span><span class="tabler-hbut"><nobr>'
			if( dc.filter && !dc.noFilter[c] ) {
				paddingRight += 30;
				txt += '<i class="fa fa-search tabler-filter"></i>';
			}
			if( dc.sort && !dc.noSort[c] ) {
				paddingRight += 30;
				txt += '<i class="fa fa-caret-up tabler-sort"></i>';
			} 
			txt += '<nobr></span>';
			// var txt = '<table><tr><td>' + cols[c] + '</td><td><span class="tabler-hbut"><nobr><i class="fa fa-filter"></i><i class="fa fa-caret-up"></i><nobr></span></td></tr></table>';
			var td = $('<th>').html(txt);
			if( dc.colWidth && dc.colWidth[c] ) td.css({width:dc.colWidth[c]+'%'})
			td.find('.tabler-sort').addClass('tabler-sort-'+idx).prop('idx',idx).on('click',sortClick);
			td.find('.tabler-filter').addClass('tabler-filter-btn tabler-filter-'+idx).prop('idx',idx).on('click',filterClick);
			td.addClass('tabler-th').addClass('tabler-th-'+idx)
			td.css({paddingRight:paddingRight});
			if( dc.headerClick ) td.css({cursor:'pointer'}).prop('idx',idx).on('click', function(){
				if( dc.headerClick == 'filter' )
					$(this).find('.tabler-filter').click();
				else
					$(this).find('.tabler-sort').click();
			} );
			tr.append(td);
			idx++;
		}
		filterPaint(1);
	}
	// var selectColCss = {textAlign:'center',width: 30};
	var refreshFilter = true;
	if( !dc.sortAlias ) dc.sortAlias = {};

	function format( row, col )
	{
		if( col != 'thumb' && isarray(row[col])) {
			var ret = [];
			for( var v of row[col] ) {
				if( col in dc.formatCol ) ret.push(dc.formatCol[col](v));
				else if( dc.format ) ret.push(dc.format(v));
				else ret.push(v || '');
			}
			// console.log( 'format', col, row[col], ret )
			return ret;
		}
		else {
			if( col in dc.formatCol )
				return dc.formatCol[col](row[col]);
			if( dc.format ) return dc.format(row[col]);
			return row[col] || '';
		}
	}

	me.rows = [];
	me.addRow = function( row, callback )
	{
		var r = {data:row,callback:callback}
		r.filter = {};
		for( var v in dc.columns )
		{
			var vdata = v;
			if( dc.sortAlias[vdata] ) vdata = dc.sortAlias[vdata];
			var val = format( r.data, vdata );
			// console.log( 'vvv', vdata, val );
			r.filter[v] = val;
			var ctype = v in dc.forceType ? dc.forceType[v] : 0;
			if( ctype == 0 ) {
				if( isarray(r.filter[v]) ) {
					r.filter[v] = r.filter[v].map( f => f.toString().replace(/(<([^>]+)>)/ig, '').toLowerCase() );
				}
				else 
					r.filter[v] = r.filter[v] ? r.filter[v].toString().replace(/(<([^>]+)>)/ig, '') : '';
			}
		}
		me.rows.push( r );
	}

	me.setDataURL = function( url )
	{
		dc.dataUrl = url;
	}

	function pagination( page, rows )
	{
		var totPages = Math.ceil( rows.length/dc.pageSize );
		var pags = $(obj).find('.pagination');
		pags.html('<div class="tabler-filter-title"></div>');

		// var pfirst = $('<li className="page-item page-first">');
		// pfirst.html('<a class="page-link" href="#" aria-label="Previous" idx="0"><span aria-hidden="true">&laquo;</span><span class="sr-only">Previous</span></a>');
		// pags.append( pfirst );


		var range = 8;
		var pini = page-range/2;
		var pfim = page+range/2;
		if( pini < 0 ) pini = 0;
		if( pfim-pini < range ) pfim = pini+range;
		if( pfim > totPages-1 ) pfim = totPages-1;
		if( pfim-pini < range ) pini = pfim-range;
		if( pini < 0 ) pini = 0;

		// console.log( 'pagination', pags[0], 'page', page, 'pini', pini, 'pfim', pfim );
		// for( var p = pini ; p <= pfim ; p++ )
		// {
		// 	var ppp = p+1;
		// 	var pnum = $('<li class="page-item page-number"><a class="page-link" href="#" idx="'+p+'">'+ppp+'</a></li>');
		// 	if( p == page ) pnum.addClass('active');
		// 	pags.append(pnum);
		// }
		// var plast = $('<li className="page-item page-last">');
		// plast.html('<a class="page-link" href="#" aria-label="Next" idx="-1"><span aria-hidden="true">&raquo;</span><span class="sr-only">Next</span></a>');
		// pags.append( plast );



		console.log( 'PPAGE', page, totPages )
		function pagCb(n) {
			var to = n-1;
			// if( to == -1 ) to = totPages-1;
			console.log( 'to page', to );
			dc.page = to*1;
			me.draw();
			saveContext();
		}

		frm.paginator( pags, page+1, totPages, pagCb  )


		$(obj).find('.page-link').off('click').on('click', function(ev){
			
			var to = $(this).attr('idx');
			if( to == -1 ) to = totPages-1;
			console.log( 'to page', to );
			dc.page = to*1;
			me.draw();
			saveContext();
			ev.preventDefault();
		})
		
		var filterTxt = '<nobr>';
		var fkeys = Object.keys(filters);
		var i1 = (dc.page)*dc.pageSize;
		var i2 = (dc.page+1)*dc.pageSize-1; if( i2 >= me.baseRows.length ) i2 = me.baseRows.length-1;
		// console.log( 'pini', pini, 'pfim', pfim, 'psize', dc.pageSize, i1, i2 )
		
		var items = me.baseRows.length == 1 ? 'item' : 'items';
		if( pini == pfim )
		{
			pags.find('li').hide();
			filterTxt = '<b>Total ';
		}
		else filterTxt = '<b>' + (i1+1) + ' - ' + (i2+1) + ' of ';
		if( fkeys && me.baseRows.length < me.rows.length )
		{
			if( pini == pfim ) filterTxt = '<b>';

			var fnames = fkeys.map( f => '<a href="#" col="'+f+'">' + dc.columns[f] + '<span> <i class="fa fa-close"></i></span></a>');
			filterTxt += '' + me.baseRows.length + '</b> '+ items +' filtered from a total of '+ me.rows.length +' <i>('+fnames.join(', ')+')</i>';
		}
		else {
			filterTxt += '' + me.rows.length + '</b>';
		}
		filterTxt += '</nobr>';
		if( pini == pfim && dc.hideSinglePageTotal ) filterTxt = '';
		pags.find('.tabler-filter-title').html(filterTxt).find('a').on('click', function(ev){
			var rfilter = $(this).attr('col');
			delete filters[rfilter];
			me.update = true;
			me.draw();
			saveContext();
			// alert( rfilter );
			ev.preventDefault();
			ev.stopPropagation();
		});
	}

	function filterRows( ignore )
	{
		var rows = [];
		console.log( 'FILTERS', filters )
		me.rows.forEach( r => {
			var ok = true;
			for( var c in filters )
			{
				if( c == ignore ) continue;
				var fok = false;
				for( var s in filters[c] )
				{
					try {
						// console.log( 'check', c, 's', s, r.filter, r.filter[c].toString().indexOf(s) );
						if( s == '' )
						{
							if( r.filter[c].toString() == '')
							{
								fok = true;
								break;
							}
						}
						else
						{
							// if( r.filter[c].toString().indexOf(s) >= 0 )
							if( r.filter[c].toString().indexOf(s) >= 0 )
							{
								fok = true;
								break;
							}
						}
					} catch(e){}
				}
				if( !fok )
				{
					ok = false;
					break;
				}
			}
			if( ok ) rows.push( r )
		})
		// console.log('rowsx', rows)
		return rows;
	}

	me.getData = function( ini, size, filter )
	{

	}

	function scheck( v ){
		// if( h ) return '<i class="fa '+ (v ?'fa-check-square' : 'fa-square') + '">';
		if( v == 2 ) return '<i class="tabck fa fa-minus-square-o">'
		return '<i class="tabck fa '+ (v ?'fa-check-square-o' : 'fa-square-o') + '">';
	}

	function selectedRow( row )
	{
		// console.log( 'srow', row[dc.selectId], row[dc.selectedId] in dc.selected )
		return row[dc.selectId] in dc.selected;
		return true;
	}

	function selectAllClick()
	{
		var s = selectedAllCheck();
		if( s == 0 )
			me.baseRows.forEach( r => dc.selected[r.data[dc.selectId]] = 1 );
		else
			me.baseRows.forEach( r => delete dc.selected[r.data[dc.selectId]] );
		saveContext();
		if( me.selectCallback ) me.selectCallback( dc.selected )
		me.draw();
	}

	function selectedAllCheck()
	{
		var allOk = 1;
		var noOk  = 1;
		me.baseRows.forEach( r=> {
			if( r.data[dc.selectId] in dc.selected ) noOk = 0;
			else allOk = 0
		})
		var s = noOk ? 0 : (allOk ? 1 : 2);
		$('.tabler-sel-col-header').html( scheck(s) );
		return s;
	}

	function selectClick( row )
	{
		console.log( 'selectClick', $(this).prop('click_data') );
		var id = $(this).prop('click_data').row[dc.selectId];
		var v = true;
		if( id in dc.selected )
		{
			delete dc.selected[id];
			v = false;
		}
		else {
			dc.selected[id] = 1;
		}
		$(this).html(scheck(v))
		selectedAllCheck();
		console.log( 'id', dc.selected );
		// window.dc = dc;
		if( me.selectCallback ) me.selectCallback( dc.selected )
		saveContext();
	}




	if( !dc.page ) dc.page = 0;
	me.draw = function()
	{
		// console.log( 'DRAW', dc.page );
		if( !me.drawn && dc.initialSort )
		{
			// console.log( 'first draw', me.rows.length )
			me.drawn = true;
			return sortData( dc.initialSort, dc.initialSortDir || 1 );
		}

		// console.log( 'CLICKALL', dc.clickAllCols )
		// filterPaint();
		$(obj).find('.tabler-content-line').remove();
		var baseRows = filterRows();
		me.baseRows = baseRows;
		selectedAllCheck();
		// console.log( 'DRAW1', dc.page, baseRows.length, me.rows.length );

		var idx = (dc.page || 0)*dc.pageSize;
		if( idx > baseRows.length ) idx = dc.page = 0;
		var rows = [];
		for( var i = idx ; rows.length < dc.pageSize && i < baseRows.length  ; i++ )
		{
			rows.push( baseRows[i] );
		}
		console.log( 'DRAW2', dc.page );
		pagination( dc.page, baseRows )
		for( var i = 0 ; i < rows.length ; i++ )
		{
			var row = rows[i].data;
			// console.log( 'row', row )
			var callback = rows[i].callback;
			var tr = $('<tr>').addClass('tabler-content-line');
			if( dc.clickAllCols && callback ) tr.addClass('tabler-click-line');
			$(obj).append(tr);
			if( dc.selectMode )
			{
				var td = $('<td>').html(scheck(selectedRow(row)))
						.prop('click_data',{row:row})
						.on('click', selectClick )
						.addClass('tabler-sel-col')
				tr.append(td);
			}
			for( var c in dc.colNum )
			{
				var colVal = format( row, c );
				var tooltip = '';
				if( isarray(colVal) ) tooltip = colVal.join(', ');
				tooltip = tooltip.replace(/(<([^>]+)>)/ig, '');
				if( isarray(colVal) && dc.maxLinesCol[c] && colVal.length > dc.maxLinesCol[c] ) {
					var dif = colVal.length - dc.maxLinesCol[c]
					colVal.splice(dc.maxLinesCol[c]);
					colVal.push(frm.smallerText('(+'+dif+')'))
				}
				var td = $('<td>').html( colVal ).prop('click_data',{col:c,row:row});
				if( tooltip ) td.attr('title',tooltip)
				if( dc.colWidth && dc.colWidth[c] ) td.css({width:dc.colWidth[c]+'%'})
				if( dc.centerCol[c] ) td.addClass('tabler-center-col');
				function cb()
				{
					filterOut();
					var cdata = $(this).prop('click_data');
					callback( cdata.col, cdata.row, $(this) );
				}
				if( callback && dc.clickCol[c] ) td.addClass('tabler-click').on('click', cb );
				tr.append(td);
			}
		}
		me.drawn = true;
		if( me.update && me.updateCallback ) me.updateCallback( me.baseRows );
		me.update = false;
		if( me.drawCallback ) me.drawCallback();
	}
	// me.ctx = function()
	// {
	// 	return {filters:dc.filters,page:dc.page,initialSort:dc.initialSort,initialSortDir:dc.initialSortDir,selected:dc.selected};
	// }
	var saveCallback = null;
	me.saveCtx = me.onSaveCtx = function(f){
		saveCallback = f;
	}
	me.onUpdate = function(f)
	{
		me.updateCallback = f;
	}

	me.onSelect = function(f) {
		me.selectCallback = f;
		me.selectCallback( dc.selected )
	}

	me.clearSelection = function() {
		dc.selected = {};
		selectedAllCheck()
		saveContext();
		if( me.selectCallback ) me.selectCallback( dc.selected )
	}

	me.onDraw = function(f)
	{
		me.drawCallback = f;
	}

	me.redraw = function() {
		drawHeader();
		me.draw();
	}
	// {
	// 	saveContext = function(){
	// 		f(me.ctx());
	// 	};
	// }
	if( ctxId ) saveContext = function(){
		setCtx( ctxId, {filters:dc.filters,page:dc.page,initialSort:dc.initialSort,initialSortDir:dc.initialSortDir,selected:dc.selected,extra:dc.extra} );
		if( saveCallback ) saveCallback();
	}
	drawHeader();
	me.formatString = sVal;
	me.formatDate = sDate;
	me.formatTimeAgo = sAgo;
	me.formatPriv = sPriv;
	me.saveContext = saveContext;
	return me;
}


function sVal( s ){ return s || '<span class="tabler-blank">-</span>'};
// function sDate( s ){ return s ? new Date(s).toString().replace(/ GMT.*/,'') : '<span class="tabler-blank"> never</span>' };
function sDate( s ){ return s ? new Date(s).toString().replace(/ GMT.*/,'') : '<span class="tabler-blank">-</span>' };
function sAgo( v ){ return v ? window.timeFromNow(v/1000) : '<span class="tabler-blank"> never</span>' };
// function sAgo( v ){ return v };
function sAgoSec( v ){ return v ? window.timeFromNow(v) : '<span class="tabler-blank"> never</span>' };
function sState( v ) { return '<span class="state_'+v+'">' +window.stateLabels[v] + '</span>' };
function sActive( v ) { return v ? '<span class="state_active">Active</span>' : '<span class="state_inactive">Inactive</span>' };
function sPriv( v ){
	var tmp = [];
	if( typeof(v) == 'string') v = v.split(',');
	v.sort().forEach( p => {
		if( !p.trim() ) return;
		tmp.push( window.privs[p.trim()] );
	})
	return tmp.join(' <br>');
}


function init( obj, descriptor, ctx )
{
	return new Tabler( obj, descriptor, ctx )
}


function getCtx( id )
{
	if( !window.GlobalVars.tablerCtx ) window.GlobalVars.tablerCtx = {};
	if( !window.GlobalVars.tablerCtx[id] ) window.GlobalVars.tablerCtx[id] = {};
	window.saveSession();
	// console.log( 'getCtx', id, window.GlobalVars.tablerCtx[id] )
	return window.GlobalVars.tablerCtx[id];
}

function setCtx( id, o )
{
	console.log( 'setCtx', id, o )
	if( !window.GlobalVars.tablerCtx ) window.GlobalVars.tablerCtx = {};
	window.GlobalVars.tablerCtx[id] = o;
	window.saveSession();
}


function clearCtx( id )
{
	if( !window.GlobalVars.tablerCtx ) return;
	console.log( 'clearCtx', id )
	delete window.GlobalVars.tablerCtx[id];
}


// NPLEXPORTEND

// ADL

export default {
	table:init,
	formatString: sVal,
	formatDate: sDate,
	formatTimeAgo: sAgo,
	formatTimeAgoSec: sAgoSec,
	formatPriv: sPriv,
	formatState: sState,
	formatActive: sActive,
	getCtx: getCtx,
	clearCtx: clearCtx,
}
// ADLEND
